import { type ErrorBoundaryProps, ErrorState } from '@/screens/workspace/components'
import { useT } from '~/core/i18n'

export default function ChatError({ error, reset }: ErrorBoundaryProps) {
  const t = useT()
  return (
    <ErrorState
      error={error}
      reset={reset}
      title={t('Failed to load chat')}
      description={t('Something went wrong while loading this chat. Please try again.')}
      loggerName='ChatError'
    />
  )
}
